"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _inputModule = _interopRequireDefault(require("./input.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Input = function Input(props) {
  var getInputClass = function getInputClass() {
    return "".concat(_inputModule["default"].input, " ").concat(props.disabled && _inputModule["default"].disabled);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.label && /*#__PURE__*/_react["default"].createElement("label", {
    "data-testid": "input-label",
    htmlFor: props.name,
    className: _inputModule["default"].label
  }, props.label), /*#__PURE__*/_react["default"].createElement("input", {
    "data-testid": "input",
    type: props.type,
    name: props.name,
    id: props.name,
    maxLength: props.maxLength,
    placeholder: props.placeholder,
    disabled: props.disabled && "disabled",
    value: props.value,
    className: getInputClass(),
    onChange: function onChange(e) {
      if (!props.disabled && props.onChange) {
        props.onChange(e);
      }
    }
  }));
};
Input.defaultProps = {
  type: "text",
  disabled: false
};
Input.propTypes = {
  name: _propTypes["default"].string.isRequired,
  maxLength: _propTypes["default"].number,
  placeholder: _propTypes["default"].string,
  type: _propTypes["default"].string,
  value: _propTypes["default"].any,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};
var _default = exports["default"] = Input;